// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d27801b","453":"a7c14350","455":"a75264c6"}[chunkId] + ".chunk.js";
};